import { withDungeonContent } from './dungeons';
export * from './dungeons';
import { professionItems, professionOffers } from './professions';
export * from './professions';
import { abilities, classes, skills, specialisations } from './content/classes';
import { combatRules } from './content/combat';
import { currencies, experienceCurve, marketplaceRules } from './content/economy';
import { equipmentSlots, equipmentTypes } from './content/equipment';
import { itemModifiers, itemTemplates } from './content/items';
import { lootTables } from './content/loot';
import { rarities } from './content/rarities';
import { chunks, dungeons, enemies, npcs, quests, regions, zones } from './content/world';
import { GameData, RawGameDataSchema } from './registry';
import { compileContentCatalog, type ContentManifest } from './content-loader';
import stillwaterPack from './content/packs/stillwater.json';
import completePack from './content/packs/greenvale-complete.json';
import worldPack from './content/packs/world-greybox.json';
export { travelAt, worldDestination } from './world-catalog';
export { compileContentCatalog } from './content-loader';
export type { ContentManifest, ContentReference } from './content-loader';
export const contentPacks = [stillwaterPack, worldPack, completePack];

export { GameData, RawGameDataSchema } from './registry';
export type { RawGameData, ParsedGameData } from './registry';
export { PRIMARY_CURRENCY_ID } from './content/economy';
export { TWO_HANDED_SLOT_TYPES } from './content/equipment';
export * from './rules/items';
export * from './rules/equipment';
export * from './rules/stats';
export * from './rules/xp';
export * from './rules/random';
export * from './rules/marketplace';
export * from './rules/world';
export * from './rules/combat';
export * from './rules/collision';
export * from './rules/quests';
export * from './rules/abilities';
export { propShapes, PLAYER_COLLISION_RADIUS, ENEMY_COLLISION_RADIUS } from './content/props';
export type { PropKind, PropShape } from './content/props';

/** The raw authored content bundle. */
export const legacyContentManifest: ContentManifest = {
  rarities,
  equipmentSlots,
  equipmentTypes,
  currencies,
  marketplaceRules,
  experienceCurve,
  combatRules,
  abilities,
  specialisations,
  classes,
  skills,
  itemTemplates,
  itemModifiers,
  lootTables,
  regions,
  zones,
  chunks,
  npcs,
  enemies,
  quests,
  dungeons,
};

export const contentManifest: ContentManifest = {
  ...legacyContentManifest,
  quests: [...quests, ...completePack.quests.map((q) => ({ contentRef: q.id }))],
};

const compiledGameData = compileContentCatalog(contentManifest, contentPacks);
export const rawGameData = withDungeonContent(
  RawGameDataSchema.parse({
    ...compiledGameData,
    itemTemplates: [...compiledGameData.itemTemplates, ...professionItems],
    serviceOffers: [...(compiledGameData.serviceOffers ?? []), ...professionOffers],
  }),
);

let cached: GameData | undefined;

/** Validated singleton. Throws at startup if content is inconsistent (fail fast, never at runtime). */
export function getGameData(): GameData {
  cached ??= GameData.load(rawGameData);
  return cached;
}

export const DEMO_ZONE_ID = 'zone.greenvale.meadows';

export { keeperOutpostPillars } from './content/world';

export { clipRoad } from './rules/world-roads';
